export default "/images/credit-card.svg?d54e03874ef5af85ae1758de03816809";